import { BooleanInput } from '@angular/cdk/coercion';
import { NgClass, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { Observable, Subject, takeUntil } from 'rxjs';
import { CommonModule } from '@angular/common';
import { TranslocoPipe } from '@ngneat/transloco';
import { AuthService } from '../../../services/auth.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

@Component({
    selector       : 'user',
    templateUrl    : './user.component.html',
    encapsulation  : ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs       : 'user',
    standalone     : true,
    imports        : [MatButtonModule, CommonModule, MatMenuModule, NgIf, MatIconModule, NgClass, MatDividerModule,TranslocoPipe],
})
export class UserComponent implements OnInit, OnDestroy
{
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;
    user: User;
    userEmail: string | null = null;
    userId: string | null = null;
    users:any;
    settingsEnabled: boolean;

    private _unsubscribeAll: Subject<any> = new Subject<any>();
    apiUrl: string = 'https://localhost:7199';
    gridData: any;
    gridView: any;
    public profilePicDataUrl: any;
    public profilePicFileName: string= '';
    public profilePicId: string = '';

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _userService: UserService,
        private authService: AuthService,
        private http: HttpClient
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        this.settingsEnabled = environment.enableSettings;
     
        this.loadUserEmail();
        this.loadUserId();
        this.loadProfilePicture();

        // Subscribe to user changes
        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) =>
            {
                this.user = user;

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
        
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    loadUserEmail(): void {
        const user = localStorage.getItem('user');
        if (user) {
            try {
                const userObj = JSON.parse(user);
                this.userEmail = userObj.email || null;
            } catch (error) {
                console.error('Error parsing user JSON:', error);
                this.userEmail = null;
            }
        } else {
            this.userEmail = null;
        }
    }

    loadUserId(): void {
        const user = localStorage.getItem('user');
        if (user) {
            try {
                const userObj = JSON.parse(user);
                this.userId = userObj.id || null;
            } catch (error) {
                console.error('Error parsing user JSON:', error);
                this.userId = null;
            }
        } else {
            this.userId = null;
        }
    }

    loadProfilePicture(): void {
        setTimeout(() => {
            const user = localStorage.getItem('user');
            if (user) {
                try {
                    setTimeout(() => {
                    const userObj = JSON.parse(user);
                    const profilePic = userObj.ProfilePic;
                    if (profilePic) {
                        this.getImage(profilePic.dataUrl).subscribe(response => {
                            this.profilePicDataUrl = response.dataUrl; 
                            this.profilePicFileName = profilePic.fileName || null;
                            this.profilePicId = profilePic.id || null;
                            console.log('Profile picture data URL:', this.profilePicDataUrl);
                            this._changeDetectorRef.markForCheck(); 
                        }, error => {
                            console.error('Error fetching profile picture:', error);
                            this.profilePicDataUrl = null;
                            this.profilePicFileName = null;
                            this.profilePicId = null;
                        });
                    } else {
                        this.profilePicDataUrl = null;
                        this.profilePicFileName = null;
                        this.profilePicId = null;
                    }

                     }, 1000);
                } catch (error) {
                    console.error('Error parsing user JSON:', error);
                    this.profilePicDataUrl = null;
                    this.profilePicFileName = null;
                    this.profilePicId = null;
                }
            } else {
                this.profilePicDataUrl = null;
                this.profilePicFileName = null;
                this.profilePicId = null;
            }
        }, 1000);
    }
    
    
    getImage(dataUrl: string): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}${dataUrl}`);
    }
    


    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Update the user status
     *
     * @param status
     */
    updateUserStatus(status: string): void
    {
        // Return if user is not available
        if ( !this.user )
        {
            return;
        }

        // Update the user
        this._userService.update({
            ...this.user,
            status,
        }).subscribe();
    }

    /**
     * Sign out
     */
    signOut(): void
    {
        this._router.navigate(['/sign-out']);
    }

    getProfile(): void {
        this._router.navigate(['/profile']);
    }

    getSettings(): void {
        this._router.navigate(['/settings']);
    }

}
